import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PrimeNgModule } from "@primeng";

import { GridModule } from "@features/grid";
import { BbTooltipModule } from "@features/bb-tooltip";

import { CssEditorModule } from "@controls/text-editors/css-editor/css-editor.module";
import { HtmlEditorModule } from "@controls/text-editors/html-editor/html-editor.module";

import { ReportingCoreModule } from "@main/reporting.v3/reporting-core.module";


import { WidgetHtmlApiService } from "@main/reporting.v3/widget.html/api/widget-html-api.service";
import { WidgetHtmlComponent } from "@main/reporting.v3/widget.html/components/widget-html.component";
import { WidgetHtmlBuilderComponent } from "@main/reporting.v3/widget.html/components/widget-html-builder.component";
import {
    WidgetHtmlPdfExportingService
} from "@main/reporting.v3/widget.html/services/widget-html-pdf-exporting.service";
import {
    WidgetHtmlPdfExportingApiService
} from "@main/reporting.v3/widget.html/api/widget-html-pdf-exporting-api.service";
import {
    WidgetHtmlAnchorProcessorService
} from "@main/reporting.v3/widget.html/services/widget-html-anchor-processor.service";
import {
    WidgetHtmlEmbeddedWidgetsService
} from "@main/reporting.v3/widget.html/services/widget-html-embedded-widgets.service";
import {
    WidgetHtmlContentProcessorService
} from "@main/reporting.v3/widget.html/services/widget-html-content-processor.service";
import {
    WidgetHtmlSyntaxTooltipComponent
} from "@main/reporting.v3/widget.html/components/widget-html-syntax-tooltip.component";
import {
    WidgetHtmlExpressionsResolverService
} from "@main/reporting.v3/widget.html/services/widget-html-expressions-resolver.service";
import {
    WidgetHtmlCodeEditorHighlightService
} from "@main/reporting.v3/widget.html/services/widget-html-code-editor-highlight.service";
import {
    HtmlBaseExpressionsParserService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-parser.service";
import {
    HtmlBaseExpressionsResultService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-result.service";
import {
    HtmlBaseExpressionsArgumentService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-argument.service";
import {
    HtmlBaseExpressionsEvaluatorService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-base-expressions-evaluator.service";
import {
    HtmlEvalDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-eval-directive.service";
import {
    HtmlForLoopDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-for-loop-directive.service";
import {
    HtmlQueryDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-query-directive.service";
import {
    HtmlWidgetDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-widget-directive.service";
import {
    HtmlRangeDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-range-directive.service";
import {
    HtmlBoolDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-bool-directive.service";
import {
    HtmlStringDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-string-directive.service";
import {
    HtmlNumberDirectiveService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-directive-evaluators/html-number-directive.service";
import {
    HtmlForLoopDirectiveParserService
} from "@main/reporting.v3/widget.html/services/html-expressions/html-expression-parsers/html-for-loop-directive-parser.service";


@NgModule({
    declarations: [
        WidgetHtmlComponent,
        WidgetHtmlBuilderComponent,
        WidgetHtmlSyntaxTooltipComponent
    ],
    providers: [
        WidgetHtmlApiService,
        HtmlEvalDirectiveService,
        HtmlBoolDirectiveService,
        HtmlRangeDirectiveService,
        HtmlQueryDirectiveService,
        HtmlStringDirectiveService,
        HtmlNumberDirectiveService,
        HtmlWidgetDirectiveService,
        HtmlForLoopDirectiveService,
        WidgetHtmlPdfExportingService,
        HtmlBaseExpressionsResultService,
        HtmlBaseExpressionsParserService,
        WidgetHtmlEmbeddedWidgetsService,
        WidgetHtmlPdfExportingApiService,
        WidgetHtmlAnchorProcessorService,
        WidgetHtmlContentProcessorService,
        HtmlForLoopDirectiveParserService,
        HtmlBaseExpressionsArgumentService,
        HtmlBaseExpressionsEvaluatorService,
        WidgetHtmlCodeEditorHighlightService,
        WidgetHtmlExpressionsResolverService,
    ],
    exports: [
        WidgetHtmlComponent,
        WidgetHtmlBuilderComponent,
        WidgetHtmlSyntaxTooltipComponent
    ],
    imports: [
        GridModule,
        CommonModule,
        PrimeNgModule,
        BbTooltipModule,

        CssEditorModule,
        HtmlEditorModule,

        ReportingCoreModule,
    ]
})
export class WidgetHtmlModule {
}